import React from 'react';
import s from '../../styles/corporate/Corporate.module.css';
import { HIKS_POINTS } from './data';
import { useScrollProgress } from './hooks';

/** HIKS — 큰 글자가 스크롤에 맞춰 금색으로 채워진다 */
const CorpHiks = () => {
  const [ref, progress] = useScrollProgress();

  return (
    <section className={s.hiks} id="hiks">
      <div className={s.hiksWord} ref={ref} aria-hidden="true" translate="no">
        <div className={s.hiksWordOutline}>HIKS</div>
        <div className={s.hiksWordFill} style={{ clipPath: `inset(0 ${100 - progress * 100}% 0 0)` }}>
          HIKS
        </div>
      </div>

      <div className={`${s.wrap} ${s.hiksGrid}`}>
        <div>
          <h2 className={`${s.hiksTitle} ${s.reveal}`}>
            더 많은 기업에게,
            <br />더 공정한 기회를.
          </h2>
          <p className={`${s.lead} ${s.reveal}`} data-delay="100">
            HIKS는 기업과 기술, 정보와 비즈니스 기회를 연결해 규모와 정보 격차에 따른 어려움을 줄이는
            플랫폼을 지향합니다. 기업의 경쟁력을 높이고 산업 전반에 새로운 연결의 가치를 더하고자
            합니다.
          </p>
          <div className={s.badge}>
            <span className={s.dot} aria-hidden="true" />
            플랫폼 준비 중
          </div>
        </div>

        <div className={s.hiksCards}>
          {HIKS_POINTS.map((point, i) => (
            <div className={`${s.hiksCard} ${s.reveal}`} data-delay={i * 80} key={point.title}>
              <div className={s.hiksCardTitle}>{point.title}</div>
              <div className={s.hiksCardBody}>{point.body}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CorpHiks;
